const EventsData = [
  {
    name: "BLITZ-PY",
    description:
      "Engage in our Rapid Coding Event, solving 15 challenges in 30 minutes. Showcase your coding fine-ness and thrive under pressure to claim victory!",
    imageUrl: "./images/poster1.jpg",
  },
  {
    name: "INAUGURATION EVENT",
    description:
      "We were honored to have Mr.Varun Vivek as the resource person for the inauguration of our club, InnovAIt-ON. His insightful talk on- 'Data Science in Daily Life' was truly enlightening.",
    imageUrl: "./images/inaugposter.png",
  },


  {
    name: "BLITZ-PY-2",
    description:
      "Engage in our Rapid Coding Event, solving 5 AI based questions in just 30 minutes. Test your quick thinking and problem-solving skills!",
    imageUrl: "./images/poster2.jpg",
  },
  {
    name: "WINNERS OF S-1, EP-2",
    description:
      "Congratulations to all !! Here is the list of winners of BLITZ-PY-2.First place- YASH VYAS, Second place- PRINCE MISHRA, Third place- NIKHIL CHOUDARY",
    imageUrl: "./images/winnersposter.png"
  },

  {
    name: "WINNERS OF S-1, EP-1",
    description:
      "Congratulations to all !!! Here is the list of winners of BLITZ-PY-1.First place- YASH VYAS, Second place- SIDDHARTH H, Third place- SAHITI REDDY",
    imageUrl: "./images/winnersposter1.png"
  },


];

export default EventsData;
